import { useFormContext } from '@calendly/form'

import { useEventType } from 'features/event_type_provider'

export const useEnabledHosts = () => {
  const { values } = useFormContext()
  const { memberships } = useEventType()
  return (values?.memberships || memberships).filter(({ enabled, _destroy }) => enabled && !_destroy)
}
